export const notes = {
  0: 'A',
  1: 'A♯',
  2: 'B',
  3: 'C',
  4: 'C♯',
  5: 'D',
  6: 'D♯',
  7: 'E',
  8: 'F',
  9: 'F♯',
  10: 'G',
  11: 'G♯'
}

export const flatNotes = {
  0: 'A',
  1: 'B♭',
  2: 'B',
  3: 'C',
  4: 'D♭',
  5: 'D',
  6: 'E♭',
  7: 'E',
  8: 'F',
  9: 'G♭',
  10: 'G',
  11: 'A♭'
}

export const scales = {
  "None": [],
  "Harmonic Minor": [0,2,3,5,7,8,11],
  "Major Scale": [0,2,4,5,7,9,11],
  "Melodic Minor Scale (Ascending)": [0,2,3,5,7,9,11],
  "Melodic Minor Scale (Descending)": [0,2,3,5,7,8,10],
  "Chromatic": [0,1,2,3,4,5,6,7,8,9,10,11],
  "Whole Tone": [0,2,4,6,8,10],
  "Pentatonic Major": [0,2,4,7,9],
  "Pentatonic Minor": [0,3,5,7,10],
  "Pentatonic Blues": [0,3,5,6,7,10],
  "Pentatonic Neutral": [0,2,5,7,10],
  "Octatonic (H-W)": [0,1,3,4,6,7,9,10],
  "Octatonic (W-H)": [0,2,3,5,6,8,9,11],
  "Ionian": [0,2,4,5,7,9,11],
  "Dorian": [0,2,3,5,7,9,10],
  "Phrygian": [0,1,3,5,7,8,10],
  "Lydian": [0,2,4,6,7,9,11],
  "Lydian Augmented": [0,2,4,6,7,8,10],
  "Lydian Minor": [0,2,4,6,8,9,11],
  "Lydian Diminished": [0,2,3,6,7,9,11],
  "Mixolydian": [0,2,4,5,7,9,10],
  "Aeolian": [0,2,3,5,7,8,10],
  "Locrian": [0,1,3,5,6,8,10],
  "Bebop Major": [0,2,4,5,7,8,9,11],
  "Bebop Minor": [0,2,3,4,5,7,9,10],
  "Bebop Dominant": [0,2,4,5,7,9,10,11],
  "Bebop Half Diminished": [0,1,3,5,6,7,8,11],
  "Dominant Pentatonic": [0,2,4,7,10],
  "Chinese 2": [0,2,5,7,9],
  "Hirajoshi 2": [0,4,5,9,11],
  "Iwato": [0,1,5,6,10],
  "Japanese (in sen)": [0,1,5,7,10],
  "Ultralocrian": [0,1,3,4,6,8,9],
  "Diatonic": [0,2,4,7,9],
  "Diminished": [0,2,3,5,6,8,9,11],
  "Diminished, Half": [0,1,3,4,6,7,9,10],
  "Diminished Whole Tone": [0,1,3,4,6,8,10],
  "Double Harmonic": [0,1,4,5,7,8,11],
  "Mohammedan": [0,2,3,5,7,8,11]
}

export const tunings = {
  "E Standard": [7, 2, 10, 5, 0, 7],
  "Drop D": [7, 2, 10, 5, 0, 5],
  "Open C": [10, 7, 3, 10, 7, 3],
  "Custom": []
}
